import React from 'react'
import { useDecision } from '@optimizely/react-sdk'
import NewRecentlyViewedProductsCarousel from '@src/routes/ProductDetail/NewRecentlyViewedProductsCarousel/NewRecentlyViewedProductsCarousel'
import RecentlyViewedProductsCarousel from '@src/components/RecentlyViewedProductsCarousel/RecentlyViewedProductsCarousel'
import { AnalyticsDispType } from '@src/types/graphql-types'

interface RecentlyViewedCarouselTestWrapperProps {
  className?: string
  dispType: AnalyticsDispType
  setShouldDisplay?: React.Dispatch<React.SetStateAction<boolean>>
  slidesToShow?: number
  condensed?: boolean
}

const RecentlyViewedCarouselTestWrapper: React.FC<
  RecentlyViewedCarouselTestWrapperProps
> = ({ className, dispType, slidesToShow, setShouldDisplay, condensed }) => {
  const [decision] = useDecision('find-1911')

  if (decision.enabled) {
    return (
      <NewRecentlyViewedProductsCarousel
        className={className}
        dispType={dispType}
        setShouldDisplay={setShouldDisplay}
      />
    )
  }

  return (
    <RecentlyViewedProductsCarousel
      className={className}
      dispType={dispType}
      slidesToShow={slidesToShow}
      setShouldDisplay={setShouldDisplay}
      condensed={condensed}
    />
  )
}

export default RecentlyViewedCarouselTestWrapper
